/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_View_AllInputs */



/**
* | output |
* | --- |
* | "All Tournaments" |
*
* @param {Tournaments_View_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_view_all = /** @type {((inputs?: Tournaments_View_AllInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_View_AllInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tous les tournois")
	if (locale === "es") return /** @type {LocalizedString} */ ("Todos los torneos")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Todos os torneios")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutti i tornei")
	return /** @type {LocalizedString} */ ("All Tournaments")
});